module.exports = __webpack_public_path__ + "img/muscles_quiz_button.cb7fc100.jpg";